import React from 'react';
import { createPortal } from 'react-dom';

const root = typeof window !== 'undefined' ? document.querySelector('#modal-root') : null;

function TransitionBlocks() {
    const Component = (
        <div className="transition-blocks-wrapper">
            <div className="transition-blue-bg js-transition-blue-bg"></div>
            <div className="transition-white-bg js-transition-white-bg"></div>
        </div>
    );

    return root ? createPortal(Component, root) : Component;
}

export default TransitionBlocks;
